import React from 'react';
import { BarGraph } from './BarGraph';
import style from './style.module.scss';
import { useSelector } from 'react-redux';
import { MakeBarGraphProps } from './helper';
import { RootState } from 'app/main/rootReducer';

const NS = 'AmountSpentDetailsPage';

/** Renders the weekly and monthly bar graphs */
export const AmountSpentDetailsPage = () => {

  const { avgWeeklySpendStats, avgMonthlySpendStats, totalMonthlySpendStats } = useSelector((state: RootState) => state.dashboardReducer);

  const avgWeeklySpendBarGraphProps = MakeBarGraphProps("Average Spend Per Week Per Service", avgWeeklySpendStats);
  const avgMonthlySpendBarGraphProps = MakeBarGraphProps("Average Spend Per Month Per Service", avgMonthlySpendStats);
  const totalMonthlySpendBarGraphProps = MakeBarGraphProps("Total Spend Per Month Per Service", totalMonthlySpendStats);

  return (
    <div className={style.bargraph}>
      <BarGraph {...avgWeeklySpendBarGraphProps} />
      <BarGraph {...avgMonthlySpendBarGraphProps} />
      <BarGraph {...totalMonthlySpendBarGraphProps} />
    </div>
  )
}